import styled from 'styled-components';

export const EmbedFrame = styled.iframe`
  height: 100%;
  width: 100%;
  border: none;
  box-shadow: none;
  border-radius: 8px;
`;
